var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AxReply',_vm._b({staticClass:"ax-publish-notes",attrs:{"for-publish-note":"","placeholder":_vm.placeholder},on:{"input":function($event){return _vm.$emit('input', $event)}}},'AxReply',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }